var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsAccountPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    stroke: "#fff",
    strokeWidth: 0.1,
    d: "M13.883 1.167C6.86 1.167 1.167 6.86 1.167 13.884c0 7.023 5.693 12.716 12.716 12.716 7.024 0 12.717-5.693 12.717-12.716 0-7.024-5.693-12.717-12.717-12.717zm0 2.1c5.864 0 10.617 4.753 10.617 10.617 0 5.863-4.753 10.616-10.617 10.616-5.863 0-10.616-4.753-10.616-10.616 0-5.864 4.753-10.617 10.616-10.617z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    d: "M18.64 7.584h-7.871c-.462 0-.839.376-.839.839 0 .462.377.838.839.838h2.254l.19.007c1.006.076 1.863.743 2.2 1.663h-4.644c-.462 0-.839.377-.839.84l.008.113c.056.409.407.725.83.725h4.648l-.007.025c-.355.989-1.299 1.68-2.387 1.683h-2.25c-.473.008-.846.392-.838.858 0 .217.094.432.252.59l5.637 5.332c.335.318.865.302 1.184-.033l.085-.108c.226-.337.184-.79-.113-1.08l-4.106-3.883.146.001.223-.006c1.846-.097 3.396-1.393 3.855-3.142l.053-.237h1.49c.462 0 .839-.376.839-.838l-.008-.114c-.056-.409-.407-.725-.831-.725h-1.494l-.014-.076c-.13-.57-.38-1.107-.725-1.572l-.019-.024 2.252.001c.462 0 .839-.376.839-.838 0-.463-.377-.839-.839-.839z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsAccountPayments);
export default __webpack_public_path__ + "static/media/icons_account_payments.60596b5c7831c3d7dcb45b347a68b9da.svg";
export { ForwardRef as ReactComponent };